<template>
    <qb-panel :title="titulo.toUpperCase()" class="qb-margin-top">
      <div class="div-titulo">
        <strong>{{contas[0].description2}}</strong> <br>
        {{contas[0].address}} {{contas[0].addressNumber}} {{contas[0].addressDistrict}} <br>
        {{contas[0].addressCity}}, {{contas[0].addressState}} <br> {{contas[0].cel}} {{contas[0].phone}}<br>
      </div>
      <table>
        <tr>
          <td>Total vencido: {{priceFormater(this.totalVencido)}}</td>
          <td>Situação: {{contas[0].situation}}</td>
          <td>Pedidos em Aberto:
            {{priceFormater((contas[0].total_pedidos < 0 ? 0 : contas[0].total_pedidos ))}}
          </td>
        </tr>
        <tr>
          <td>Total a vencer:  {{priceFormater(this.totalVencer)}}</td>
          <td>Limite de crédito: {{priceFormater(contas[0].cashLevel)}} </td>
        </tr>
        <tr>
          <td>Total: {{priceFormater(this.total)}}</td>
          <td>Total Disponível: {{priceFormater((this.totalDisponivel < 0 ? 0 : this.totalDisponivel ))}}</td>
        </tr>
      </table>
      <table>
        <thead>
          <tr>
            <th>Títulos</th>
            <th>Vencimento</th>
            <th>Valor</th>
            <th>Situação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(conta, index) in contas" :key="conta.numberDuplicate" v-if="conta.dateExpired != '01/01/0001'">
            <td>{{conta.numberDuplicate}}</td>
            <td>{{conta.dateExpired }}</td>
            <td>{{priceFormater(conta.cash)}}</td>
            <td>{{(
              conta.state == 'Q' ? 'PAGO' : 'EM ABERTO'               
              )}}</td>
          </tr>
        </tbody>
      </table>
    </qb-panel>
</template>

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { userKey } from "@/global";

export default {
name: 'Relatório',

  components: {
  },

  data(){
      return{
        contas: [],
        totalVencido: 0,
        totalVencer: 0,
        total: 0,
        totalDisponivel:0,
        titulo: 'Financeiro',
        paginas: 0,
        message:'',
        paginaAtual: 0,
        listaPronta: false,
        vazio: false
    }
  },

   methods:{
        carregaLista(){
          const json = localStorage.getItem(userKey);
          const userData = JSON.parse(json);
          this.message = '';
          if(userData.vendedor!=""){
            const vinculado = JSON.parse(localStorage.getItem('cliente_vinculado'));
            this.Consultar(vinculado.id);
          }else{
            this.Consultar(userData.idCliente);
          }
          
        },
        Consultar(idCliente){
            axios.get(`${baseApiUrl}/reports/Relatorio/?idCliente=${idCliente}`)
            .then(res => {
             this.contas = res.data;
              const pedidos = (res.data[0].total_pedidos ? res.data[0].total_pedidos : 0 );
              const CR = (res.data[0].total_cr ? res.data[0].total_cr : 0 );
              const CD = (res.data[0].total_cd ? res.data[0].total_cd : 0 );
             if(res.data.length > 0 && res.data[0].dateExpired != '01/01/0001'){
              res.data.forEach(conta => {
                console.log(conta.cash);
                var dataVencimento = conta.dateExpired.split('/');
                const today = new Date();
                if( 
                  parseInt(dataVencimento[2]) < parseInt(today.getFullYear() ) && conta.state == "A" || 
                  ( parseInt(dataVencimento[2]) == parseInt(today.getFullYear() ) && parseInt(dataVencimento[1]) < parseInt(today.getMonth()+1) && conta.state == "A") ||
                  ( parseInt(dataVencimento[2]) == parseInt(today.getFullYear() ) && parseInt(dataVencimento[1]) == parseInt(today.getMonth()+1) && parseInt(dataVencimento[0]) < parseInt(today.getDate()) && conta.state == "A")
                  ){
                    this.totalVencido += conta.cash;   
                }else if (
                   parseInt(dataVencimento[2]) > parseInt(today.getFullYear() ) && conta.state == "A" || 
                  ( parseInt(dataVencimento[2]) == parseInt(today.getFullYear() ) && parseInt(dataVencimento[1]) > parseInt(today.getMonth()+1) && conta.state == "A") ||
                  ( parseInt(dataVencimento[2]) == parseInt(today.getFullYear() ) && parseInt(dataVencimento[1]) == parseInt(today.getMonth()+1) && parseInt(dataVencimento[0]) >= parseInt(today.getDate())  && conta.state == "A")
                ){
                  this.totalVencer += conta.cash;
                }
              });
             }if(res.data.length==0){
               alert('Não há dados a relatar.');
               window.location.reload();
             }
             this.total += this.totalVencer + this.totalVencido ;
             this.totalDisponivel = res.data[0].cashLevel - (this.total + res.data[0].total_pedidos);
            });
        },
        priceFormater(discountPrice){
          return discountPrice.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
   },
    created(){
      this.date = new Date();
      this.carregaLista();        
    },
  }
</script>

<style>

  table
  {
    width: 100%;
    padding: 10px;
  }
  table thead th
  {
    text-align: left;
    border-bottom: 1px solid silver;
  }


  .div-titulo
  {
    margin-right: auto;
    margin-left: 10px;
  }

  .div-titulo strong
  {
   font-size: 20px; 
  }
</style>
